import React from 'react';
import { HStack, Box } from '@chakra-ui/react';

interface RegistrationFormProgressBarsProps {
    currentStep: number;
    totalSteps: number;
}

export const RegistrationFormProgressBars: React.FC<RegistrationFormProgressBarsProps> = ({
    currentStep,
    totalSteps,
}) => {
    return (
        <HStack gap={2} align="center" w="full" aria-label="Registration progress">
            {Array.from({ length: totalSteps }, (_, i) => {
                const isPast = i < currentStep;
                const isCurrent = i === currentStep;
                return (
                    <Box
                        key={i}
                        flex={1}
                        transition="height 0.2s ease, background-color 0.2s ease"
                        h={isCurrent ? '8px' : '6px'}
                        bg={isPast ? 'yellow.600' : isCurrent ? 'yellow.600' : 'yellow.200'}
                    />
                );
            })}
        </HStack>
    );
};
